import _ from 'lodash';
import axios from '@/axios.js';
import qs from 'qs';

const state = {
  proxies: [],
}

const mutations = {
  SET_PROXIES: (state, payload) => {
    state.proxies = payload;
  },
};

const actions = {
  list: ({ commit }, options) => {
    const params = _.omitBy({
      ip: options.ip || undefined,
      source: options.source || undefined,
      limit: options.itemsPerPage || undefined,
      skip: options.page ? ((options.page - 1) * options.itemsPerPage) : undefined,
    }, _.isUndefined);

    return axios.get(`/proxies?${qs.stringify(params)}`).then((response) => {
      commit('SET_PROXIES', response.data);
      return response.data;
    });
  },
};

const getters = {};

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}

